import React from 'react';

import { Form, Select } from 'antd';
import { WrapperSelect } from 'common/components';
import { useFormatMessage } from 'hooks';

import { QUERIES_DATA_FORMAT } from 'static/Constants';

import Messages from 'i18n/messages/folder';

const { Option } = Select;

const formLayout = { labelCol: { span: 5 }, wrapperCol: { span: 10 } };

const DownloadFolderQuerySetting = () => {
  const messages = useFormatMessage(Messages);

  return (
    <Form.Item
      {...formLayout}
      name='queryDataFormat'
      label={messages.memberDataFormat}
    >
      <WrapperSelect getPopupContainer={(trigger) => trigger.parentElement}>
        {QUERIES_DATA_FORMAT.map((option, index) => {
          return (
            <Option key={index} value={option?.toUpperCase()}>
              {option?.toUpperCase()}
            </Option>
          );
        })}
      </WrapperSelect>
    </Form.Item>
  );
};

export default DownloadFolderQuerySetting;
